import angular from 'angular';
// import _ from 'lodash';

(function () {
    'use strict';

    angular.module('app.core').component('kissPaymentSellerAutocompleteFilter', {
        bindings: {
            sellerSelected: '=',
        },
        controller: PaymentSellerAutocompleteFilterController,
        templateUrl: require('./payment-seller-autocomplete-filter.html'),
    });

    PaymentSellerAutocompleteFilterController.$inject = ['PaymentSvc'];

    function PaymentSellerAutocompleteFilterController(PaymentSvc) {
        var ctrl = this;
        ctrl.searchBeneficiaries = searchBeneficiaries;

        /**
         * Recherche des fournisseurs bénéficiaires dans la brique de paiement.
         */
        function searchBeneficiaries(value) {
            if (value && value.length >= 3) {
                return PaymentSvc.searchBeneficiaries(value).then(benef => benef);
            }
        }
    }
})();
